import React, {useEffect, useState} from 'react';
import BaseContent from '../../../components/Common/BaseContent';
import ScreensList from "./ScreensList";
import axios from "axios";
import {API_URL} from "../../../config";
import {getAxiosDefaultConfig} from "../../../utils";
import Loader from "./components/Loader";
import {Col, Container, Row} from "reactstrap";
import PaginationComponent from "react-reactstrap-pagination";
import {useLocation} from "react-router";

const breadcrumbs = [{title: 'Screens', link: '/screens'}]

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Screens = (props) => {

  let query = useQuery()
  const pageVar = query.get('page')
  const [page, setPage] = useState(pageVar?pageVar:0)
  const [screens, setScreens] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const getAllScreens = (page) => {
    setIsLoading(true)
    axios.get(`${API_URL}/str/screens?page=${page}`,getAxiosDefaultConfig())
      .then((response) => {
        const {data} = response;
        setScreens(data);
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
      })
  }

  useEffect(()=>{
    getAllScreens(page)
    // eslint-disable-next-line
  },[page])

  const handleSelectPage = (page) => {
    setPage(page-1)
  }

  return (
    <BaseContent
      // isLoading={isLoading||!screens}
      breadcrumbs={breadcrumbs}
    >
      {(isLoading||!screens)&&<Loader />}
      {screens&&<Container style={{paddingTop: 30, minHeight: '60vh'}}>

        <ScreensList result={screens.content} isLoading={isLoading} />

        <Row>
          <Col xs={{size:6,offset:6}} className='listing-navigation'>
            <PaginationComponent defaultActivePage={screens.pageable.pageNumber+1} totalItems={screens.totalElements} pageSize={screens.pageable.pageSize} onSelect={handleSelectPage} />
          </Col>
        </Row>

    </Container>}

    </BaseContent>
  )
}

export default Screens
